import { Doughnut, mixins } from "vue-chartjs";
export default {
  extends: Doughnut,
  props: {
    chartData: {
      type: Object,
    },
    extraOptions: {
      type: Object,
    },
  },
  mixins: [mixins.reactiveProp],
  mounted() {
    this.$watch('chartData', (newVal) => {
      if (newVal && newVal.labels.length) {
        this.renderChart(newVal, this.extraOptions)
      }
    })
  }
};
